"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageReposManager = void 0;
var react_1 = __importStar(require("react"));
var styled_1 = require("./styled");
/**
 * fiddle for dealing with rotation: https://jsfiddle.net/wunderbart/w1hw5kv1/
 */
var ImageReposManager = function (_a) {
    var fullWidthOrFullHeightImg = _a.fullWidthOrFullHeightImg, wrapperRef = _a.wrapperRef, renderedImageRef = _a.renderedImageRef, setUnderEditImageData = _a.setUnderEditImageData;
    var repositionDirection = fullWidthOrFullHeightImg === "fullWidth"
        ? "vertical"
        : fullWidthOrFullHeightImg === "fullHeight" && "horizontal"; //temp
    var getRenderedImageHeight = function (imgRef) { var _a; return (_a = imgRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight; };
    var getRenderedImageWidth = function (imgRef) { var _a; return (_a = imgRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth; };
    var _b = (0, react_1.useState)(null), initialY = _b[0], setInitialY = _b[1];
    var _c = (0, react_1.useState)(0), yOffset = _c[0], setYOffset = _c[1];
    var _d = (0, react_1.useState)(null), initialX = _d[0], setInitialX = _d[1];
    var _e = (0, react_1.useState)(0), xOffset = _e[0], setXOffset = _e[1];
    var _f = (0, react_1.useState)(false), mouseIsDown = _f[0], setMouseIsDown = _f[1];
    var onMouseDown = function (e) {
        setMouseIsDown(true);
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        var clientY = e.touches ? e.touches[0].clientY : e.clientY;
        repositionDirection === "horizontal"
            ? setInitialX(clientX - xOffset)
            : setInitialY(clientY - yOffset);
        /*
        If this function has been triggered by a touch event,
        then, temp disable html scroll, else the image reposition 'drag' wont work.
    
        This ofcourse doesnt hold true for desktop.
        */
        // if(ops.isTouchStart){
        //   document //this is so that on mobile repos works, else, it ends up scrolling the page
        //   .getElementsByTagName('html')[0]
        //   .setAttribute('style', 'overflow: hidden')  
        // // }
    };
    var onMouseUp = function () {
        setMouseIsDown(false);
        // document.getElementsByTagName('html')[0].removeAttribute('style')
    };
    var onMouseOver = function () { return setMouseIsDown(false); };
    var repositionVertical = function (e) {
        if (mouseIsDown === true) {
            var clientY = e.touches ? e.touches[0].clientY : e.clientY;
            var currentY_1 = clientY - initialY;
            var renderedImgHeight_1 = getRenderedImageHeight(renderedImageRef);
            // (imgHeight * wrapperRef.current.clientWidth) / imgWidth; //actual rendered height of image
            var wrapperHeight = wrapperRef.current.clientHeight;
            if (currentY_1 <= 0 && currentY_1 >= -(renderedImgHeight_1 - wrapperHeight)) {
                setYOffset(currentY_1);
                setUnderEditImageData(function (prev) { return (__assign(__assign({}, prev), { cropY: (currentY_1 / renderedImgHeight_1) * 100 })); });
                // setImgPosY((currentY / renderedImgHeight) * 100); //finally set the y-translate in percentage so that it works in different container sizes
            }
        }
    };
    var repositionHorizontal = function (e) {
        if (mouseIsDown === true) {
            var clientX = e.touches ? e.touches[0].clientX : e.clientX;
            var currentX_1 = clientX - initialX;
            var renderedImgWidth_1 = getRenderedImageWidth(renderedImageRef);
            // (imgWidth * wrapperRef.current.clientHeight) / imgHeight; //actual rendered width of image
            var wrapperWidth = wrapperRef.current.clientWidth;
            if (currentX_1 <= 0 && currentX_1 >= -(renderedImgWidth_1 - wrapperWidth)) {
                setXOffset(currentX_1);
                setUnderEditImageData(function (prev) { return (__assign(__assign({}, prev), { cropX: (currentX_1 / renderedImgWidth_1) * 100 })); });
                // setImgPosX((currentX / renderedImgWidth) * 100); //finally set the x-translate in percentage so that it works in different container sizes
            }
        }
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(styled_1.StyledHorLayoutGrid, null),
            react_1.default.createElement(styled_1.StyledVerLayoutGrid, null)),
        react_1.default.createElement("div", { style: {
                top: "0",
                cursor: "move",
                position: "absolute",
                width: "100%",
                height: "100%",
                touchAction: 'none' //very important, ensures that touch drag doesnt scroll the page
            }, onMouseDown: function (e) { return onMouseDown(e); }, onTouchStart: function (e) { return onMouseDown(e); }, onMouseUp: onMouseUp, onTouchEnd: onMouseUp, onMouseOver: onMouseOver, onMouseMove: function (e) {
                return repositionDirection === "vertical"
                    ? repositionVertical(e)
                    : repositionHorizontal(e);
            }, onTouchMove: function (e) {
                e.preventDefault();
                repositionDirection === "vertical"
                    ? repositionVertical(e)
                    : repositionHorizontal(e);
            } })));
};
exports.ImageReposManager = ImageReposManager;
